import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/images/welcome/welcome1.png'


const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 welcome-box" }
const _hoisted_2 = { class: "card-body pe-15 pe-sm-20 pe-md-0 pb-0 pt-15 pt-sm-20" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = { class: "col-lg-6 col-md-6" }
const _hoisted_5 = { class: "title position-relative" }
const _hoisted_6 = { class: "fw-semibold mb-8" }
const _hoisted_7 = { class: "fw-bold" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black-emphasis fs-md-15 fs-lg-16" }, " Here’s what happening with your store today ", -1)
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<ul class=\"ps-0 mb-0 list-unstyled\"><li class=\"d-inline-block text-uppercase fw-medium fs-13 text-black-emphasis position-relative\"> TODAY’S VISIT <span class=\"d-block fw-black lh-1 text-black mt-5 mt-md-10\"> 15,209 </span></li><li class=\"d-inline-block text-uppercase fw-medium fs-13 text-black-emphasis position-relative\"> TODAY’S TOTAL SALES <span class=\"d-block fw-black lh-1 text-black mt-5 mt-md-10\"> $29,115.50 </span></li></ul>", 1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 col-md-6 text-center mt-15 mt-md-0" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "welcome-image"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", _hoisted_6, [
              _createTextVNode(" Good Morning, "),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.userName) + "!", 1)
            ]),
            _hoisted_8
          ]),
          _hoisted_9
        ]),
        _hoisted_10
      ])
    ])
  ]))
}